export default __webpack_public_path__ + "static/media/99.d156302b.png";